<template>
  <v-dialog v-model="dialog" scrollable max-width="1200">
    <v-card>
      <v-card-title>
        組織情報編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 800px">
        <v-form ref="organization_form">
          <v-container>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mb-n5">
              <v-col cols="12" sm="12" md="2">
                <FormInputComponent
                  label="組織キー"
                  v-model="organizationKey"
                  type="String"
                  rules="required"
                  :counter="10"
                  :disabled="organizationKeyShow"
                />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mb-n5">
              <v-col cols="12" sm="4" md="12">
                <FormInputComponent
                  label="組織名"
                  v-model="organizationName"
                  type="String"
                  rules="required"
                  :counter="10"
                />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mb-n5">
              <v-col cols="12" sm="4" md="6">
                <FormInputComponent
                  label="初期パスワード"
                  v-model="entryInitialPassword"
                  type="password"
                  rules="passwordRules"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="4" md="6">
                <FormInputComponent
                  label="初期パスワード再"
                  v-model="entryInitialPasswordRetry"
                  type="password"
                  rules="passwordRules"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mt-n10 mb-n10">
              <v-col cols="12" sm="4" md="12">
                <DatePicker v-model="startOperatingDate" label="運用開始日" />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mt-n6 mb-n2">
              <v-col cols="12" sm="4" md="12">
                <DatePicker v-model="endOperatingDate" label="運用終了日" />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mb-n5">
              <v-col cols="12" sm="4" md="12">
                <FormInputComponent
                  label="システムオペレーターログイン名"
                  v-model="sysopLoginId"
                  type="String"
                  rules="loginIdRules"
                  :counter="256"
                />
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 pl-0 pr-0">
              <v-col cols="12" sm="4" md="6">
                <FormInputComponent
                  label="システムオペレーターパスワード"
                  v-model="entrySysopPassword"
                  type="password"
                  rules="passwordRules"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="4" md="6">
                <FormInputComponent
                  label="システムオペレーターパスワード再"
                  v-model="entrySysopPasswordRetry"
                  type="password"
                  rules="passwordRules"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <div style="text-align: left; padding: 0px; margin: 0px">
              <p>
                <small>※プラスの氣を入力する際の最小文字数を変更します。</small>
              </p>
            </div>
            <v-row class="pt-0 pb-0 pl-0 pr-0 mb-n5">
              <v-col cols="12" sm="4" md="6">
                <FormInputComponent
                  label="プラスの氣入力最小文字数"
                  v-model="commentMinString"
                  type="number"
                  rules="commentMinStringRules"
                  :counter="4"
                />
              </v-col>
            </v-row>
            <div style="text-align: left; padding: 0px; margin: 0px">
              <p><small>※優先度1～5の名称を変更します。</small></p>
            </div>
            <v-row>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="ユーザランク(優先度1)"
                  v-model="userRankName1"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="ユーザランク(優先度2)"
                  v-model="userRankName2"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="ユーザランク(優先度3)"
                  v-model="userRankName3"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="ユーザランク(優先度4)"
                  v-model="userRankName4"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="ユーザランク(優先度5)"
                  v-model="userRankName5"
                  rules="required"
                  :counter="10"
                />
              </v-col>
            </v-row>
            <div style="text-align: left; padding: 0px; margin: 0px">
              <p>
                <small>※人事考課シートのタイトル名称を変更します。</small>
              </p>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="総合目標タイトル1"
                  v-model="totalGoalTitle1"
                  rules="required"
                  :counter="50"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="総合目標タイトル2"
                  v-model="totalGoalTitle2"
                  rules="required"
                  :counter="50"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="総合目標タイトル3"
                  v-model="totalGoalTitle3"
                  rules="required"
                  :counter="50"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="人間力タイトル"
                  v-model="humanPowerTitle"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="チャレンジ目標タイトル"
                  v-model="challengeGoalTitle"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="総合目標タイトル"
                  v-model="totalTargetTitle"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="振り返りタイトル"
                  v-model="commentTitle"
                  rules="required"
                  :counter="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <FormInputComponent
                  label="最終確認タイトル"
                  v-model="lastConfirmTitle"
                  rules="required"
                  :counter="10"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題自己_タイトル1"
                  v-model="taskSelfTitle1"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題自己_タイトル2"
                  v-model="taskSelfTitle2"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題自己_タイトル3"
                  v-model="taskSelfTitle3"
                  rules="required"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題管理_タイトル1"
                  v-model="taskManageTitle1"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題管理_タイトル2"
                  v-model="taskManageTitle2"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <FormInputComponent
                  label="課題管理_タイトル3"
                  v-model="taskManageTitle3"
                  rules="required"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <div style="text-align: left; padding: 0px; margin: 0px">
              <p>
                <small>※評価を行う際の記号の設定をします。</small>
              </p>
            </div>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="評価記号１"
                  v-model="symbolMark1"
                  :counter="3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="ポイント１"
                  v-model="symbolPoint1"
                  type="number"
                  :counter="3"
                  clearable
                  ref="symbolPoint1"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="4"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="凡例１"
                  v-model="symbolExample1"
                  :counter="20"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <v-select
                  label="使用状態１"
                  v-model="symbolExpiration1"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="評価記号２"
                  v-model="symbolMark2"
                  :counter="3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="ポイント２"
                  v-model="symbolPoint2"
                  type="number"
                  :counter="3"
                  clearable
                  ref="symbolPoint2"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="4"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="凡例２"
                  v-model="symbolExample2"
                  :counter="20"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <v-select
                  label="使用状態２"
                  v-model="symbolExpiration2"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="評価記号３"
                  v-model="symbolMark3"
                  :counter="3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="ポイント３"
                  v-model="symbolPoint3"
                  type="number"
                  :counter="3"
                  clearable
                  ref="symbolPoint3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="4"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="凡例３"
                  v-model="symbolExample3"
                  :counter="20"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <v-select
                  label="使用状態３"
                  v-model="symbolExpiration3"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="評価記号４"
                  v-model="symbolMark4"
                  :counter="3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="ポイント４"
                  v-model="symbolPoint4"
                  type="number"
                  :counter="3"
                  clearable
                  ref="symbolPoint4"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="4"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="凡例４"
                  v-model="symbolExample4"
                  :counter="20"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <v-select
                  label="使用状態４"
                  v-model="symbolExpiration4"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="評価記号５"
                  v-model="symbolMark5"
                  :counter="3"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="ポイント５"
                  v-model="symbolPoint5"
                  type="number"
                  :counter="3"
                  clearable
                  ref="symbolPoint5"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="4"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <FormInputComponent
                  label="凡例５"
                  v-model="symbolExample5"
                  :counter="20"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="2"
                class="pt-0 pb-0 pl-3 pr-3 ma-0"
              >
                <v-select
                  label="使用状態５"
                  v-model="symbolExpiration5"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" sm="4" md="2">
                <v-checkbox
                  v-model="chkHitonobi1"
                  label="プラスの氣"
                  color="red"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="3" sm="4" md="3">
                <v-checkbox
                  v-model="chkHitonobi2"
                  label="人事考課"
                  color="indigo"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <Loader :loading="loading" />
        <v-row class="text-left pt-0 pb-0 pl-3 pr-0">
          <v-col cols="2">
            <Button @click="erntry_confirm" color="primary">登録</Button>
          </v-col>
          <v-col>
            <Button v-show="editFlg" @click="delete_confirm" color="danger"
              >削除</Button
            >
          </v-col>
        </v-row>

        <ConfirmDialog
          ref="confirm"
          title="組織情報編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editOrganizationInfo"
        >
        </ConfirmDialog>

        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import {
  encrypt256,
  getSessionStorageItem,
  chackDateFormatStr,
  makeDateFormatStr,
  convertStr,
  makeLoginId,
} from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    entryFlg: false,
    editFlg: false,
    deleteFlg: false,
    resolve: null,
    reject: null,

    loading: false,
    confirmMessage: null,

    // 組織キー活性・非活性
    organizationKeyShow: false,

    // 組織キー
    organizationKey: '',
    // 組織名
    organizationName: '',
    initialPassword: '',
    // 初期パスワード
    entryInitialPassword: '',
    // 初期パスワード(再)
    entryInitialPasswordRetry: '',
    commentMinString: 0,
    // 運用開始日
    startOperatingDate: '',
    // 運用終了日
    endOperatingDate: '',
    // Hitonobi機能選択(プラスの氣)
    chkHitonobi1: false,
    // Hitonobi機能選択(人事考課)
    chkHitonobi2: false,

    // ユーザランク名称
    userRankName1: config.USER_RANK_NAME_1,
    userRankName2: config.USER_RANK_NAME_2,
    userRankName3: config.USER_RANK_NAME_3,
    userRankName4: config.USER_RANK_NAME_4,
    userRankName5: config.USER_RANK_NAME_5,
    // 評価記号マーク
    symbolMark1: config.SYMBOL_MARK_1,
    symbolMark2: config.SYMBOL_MARK_2,
    symbolMark3: config.SYMBOL_MARK_3,
    symbolMark4: config.SYMBOL_MARK_4,
    symbolMark5: config.SYMBOL_MARK_5,
    // 評価記号ポイント
    symbolPoint1: config.SYMBOL_POINT_1,
    symbolPoint2: config.SYMBOL_POINT_2,
    symbolPoint3: config.SYMBOL_POINT_3,
    symbolPoint4: config.SYMBOL_POINT_4,
    symbolPoint5: config.SYMBOL_POINT_5,
    // 評価記号凡例
    symbolExample1: config.SYMBOL_EXAMPLE_1,
    symbolExample2: config.SYMBOL_EXAMPLE_2,
    symbolExample3: config.SYMBOL_EXAMPLE_3,
    symbolExample4: config.SYMBOL_EXAMPLE_4,
    symbolExample5: config.SYMBOL_EXAMPLE_5,
    // 評価記号使用状態
    symbolExpiration1: config.USE_IN,
    symbolExpiration2: config.USE_IN,
    symbolExpiration3: config.USE_IN,
    symbolExpiration4: config.USE_STOP,
    symbolExpiration5: config.USE_STOP,
    isActiveLabels: [
      { label: config.USE_IN_NAME, value: config.USE_IN },
      { label: config.USE_STOP_NAME, value: config.USE_STOP },
    ],

    // 総合目標タイトル
    totalGoalTitle1: config.TOTAL_GOAL_TITLE_1,
    totalGoalTitle2: config.TOTAL_GOAL_TITLE_2,
    totalGoalTitle3: config.TOTAL_GOAL_TITLE_3,
    // 各種タイトル
    humanPowerTitle: config.HUMAN_POWER_TITLE,
    challengeGoalTitle: config.CHALLENGE_GOAL_TITLE,
    totalTargetTitle: config.TOTAL_TARGET_TITLE,
    commentTitle: config.COMMENT_TITLE,
    lastConfirmTitle: config.LAST_CONFIRM_TITLE,
    // 課題自己タイトル
    taskSelfTitle1: config.TASK_SELF_TITLE_1,
    taskSelfTitle2: config.TASK_SELF_TITLE_2,
    taskSelfTitle3: config.TASK_SELF_TITLE_3,
    // 課題管理タイトル
    taskManageTitle1: config.TASK_MANAGE_TITLE_1,
    taskManageTitle2: config.TASK_MANAGE_TITLE_2,
    taskManageTitle3: config.TASK_MANAGE_TITLE_3,
    // 作成状態
    userMakeStaus: config.EXEC_STOP,
    goalMakeStaus: config.EXEC_STOP,

    // 更新日
    createdAt: null,
    updateAt: null,

    // システムオペレーターログイン名
    sysopLoginId: null,
    sysopPassword: null,
    // システムオペレーターパスワード
    entrySysopPassword: '',
    // システムオペレーターパスワード(再)
    entrySysopPasswordRetry: '',
    sysopUserId: null,

    options: {
      color: 'primary',
      width: 300,
    },
  }),
  created() {
    let vm = this;
    vm.$forceUpdate();
  },
  methods: {
    afterselection(item) {
      console.log(item);
      this.$nextTick(() => {
        this.selected = null;
      });
    },
    open(item) {
      this.dialog = true;
      this.confirm = false;

      if (item == null) {
        this.entryFlg = true;
        this.editFlg = false;

        this.organizationKey = '';
        this.organizationName = '';
        this.initialPassword = '';
        this.entryInitialPassword = '';
        this.entryInitialPasswordRetry = '';
        this.startOperatingDate = moment().format('YYYY-MM-DD');
        this.endOperatingDate = '';
        this.expiration = { label: '', value: '' };
        this.createdAt = '';
        this.updateAt = '';
        this.sysopUserId = '';
        this.sysopLoginId = '';
        this.sysopPassword = '';
        this.entrySysopPassword = '';
        this.entrySysopPasswordRetry = '';

        // ユーザランク名称
        this.userRankName1 = config.USER_RANK_NAME_1;
        this.userRankName2 = config.USER_RANK_NAME_2;
        this.userRankName3 = config.USER_RANK_NAME_3;
        this.userRankName4 = config.USER_RANK_NAME_4;
        this.userRankName5 = config.USER_RANK_NAME_5;
        // 評価記号マーク
        this.symbolMark1 = config.SYMBOL_MARK_1;
        this.symbolMark2 = config.SYMBOL_MARK_2;
        this.symbolMark3 = config.SYMBOL_MARK_3;
        this.symbolMark4 = config.SYMBOL_MARK_4;
        this.symbolMark5 = config.SYMBOL_MARK_5;
        // 評価記号ポイント
        this.symbolPoint1 = config.SYMBOL_POINT_1;
        this.symbolPoint2 = config.SYMBOL_POINT_2;
        this.symbolPoint3 = config.SYMBOL_POINT_3;
        this.symbolPoint4 = config.SYMBOL_POINT_4;
        this.symbolPoint5 = config.SYMBOL_POINT_5;
        // 評価記号凡例
        this.symbolExample1 = config.SYMBOL_EXAMPLE_1;
        this.symbolExample2 = config.SYMBOL_EXAMPLE_2;
        this.symbolExample3 = config.SYMBOL_EXAMPLE_3;
        this.symbolExample4 = config.SYMBOL_EXAMPLE_4;
        this.symbolExample5 = config.SYMBOL_EXAMPLE_5;
        // 評価記号使用状態
        this.symbolExpiration1 = config.USE_IN;
        this.symbolExpiration2 = config.USE_IN;
        this.symbolExpiration3 = config.USE_IN;
        this.symbolExpiration4 = config.USE_STOP;
        this.symbolExpiration5 = config.USE_STOP;
        // 総合目標タイトル
        this.totalGoalTitle1 = config.TOTAL_GOAL_TITLE_1;
        this.totalGoalTitle2 = config.TOTAL_GOAL_TITLE_2;
        this.totalGoalTitle3 = config.TOTAL_GOAL_TITLE_3;
        // 各種タイトル
        this.humanPowerTitle = config.HUMAN_POWER_TITLE;
        this.challengeGoalTitle = config.CHALLENGE_GOAL_TITLE;
        this.totalTargetTitle = config.TOTAL_TARGET_TITLE;
        this.commentTitle = config.COMMENT_TITLE;
        this.lastConfirmTitle = config.LAST_CONFIRM_TITLE;
        // 課題自己タイトル
        this.taskSelfTitle1 = config.TASK_SELF_TITLE_1;
        this.taskSelfTitle2 = config.TASK_SELF_TITLE_2;
        this.taskSelfTitle3 = config.TASK_SELF_TITLE_3;
        // 課題管理タイトル
        this.taskManageTitle1 = config.TASK_MANAGE_TITLE_1;
        this.taskManageTitle2 = config.TASK_MANAGE_TITLE_2;
        this.taskManageTitle3 = config.TASK_MANAGE_TITLE_3;
        // 作成状態
        this.userMakeStaus = config.EXEC_STOP;
        this.goalMakeStaus = config.EXEC_STOP;

        // チェックボックス
        this.chkHitonobi1 = false;
        this.chkHitonobi2 = false;
        // 組織キー活性
        this.organizationKeyShow = false;
      } else {
        this.entryFlg = false;
        this.editFlg = true;

        this.organizationKey = item.ORGANIZATION_KEY;
        this.organizationName = item.ORGANIZATION_NAME;
        this.initialPassword = item.INITIAL_PASSWORD;
        this.entryInitialPassword = item.INITIAL_PASSWORD.substr(0, 10);
        this.entryInitialPasswordRetry = this.entryInitialPassword;
        this.commentMinString = Number(item.COMMENT_MIN_STRING);
        this.expiration = item.EXPIRATION;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;

        if (
          item.START_OPERATING_DATE != null &&
          item.START_OPERATING_DATE.trim()
        ) {
          // 運用開始日
          this.startOperatingDate = item.START_OPERATING_DATE.replaceAll(
            '/',
            '-'
          );

          // 運用終了日
          if (item.END_OPERATING_DATE != config.END_OPERATING_DATE_PLAY) {
            this.endOperatingDate = item.END_OPERATING_DATE.replaceAll(
              '/',
              '-'
            );
          } else {
            this.endOperatingDate = null;
          }
        } else {
          this.startOperatingDate = null;
          this.endOperatingDate = null;
        }

        if (this.expiration == config.EXPIRATION_PURASUNOKI) {
          // プラスの氣のみ選択
          this.chkHitonobi1 = true;
          this.chkHitonobi2 = false;
        } else if (this.expiration == config.EXPIRATION_JINJI) {
          // 人事考課のみ選択
          this.chkHitonobi1 = false;
          this.chkHitonobi2 = true;
        } else {
          // 両方
          this.chkHitonobi1 = true;
          this.chkHitonobi2 = true;
        }

        // ユーザランク名称
        this.userRankName1 = item.USER_RANK_NAME_1;
        this.userRankName2 = item.USER_RANK_NAME_2;
        this.userRankName3 = item.USER_RANK_NAME_3;
        this.userRankName4 = item.USER_RANK_NAME_4;
        this.userRankName5 = item.USER_RANK_NAME_5;
        // 評価記号
        this.symbolMark1 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_MARK_1
        );
        this.symbolMark2 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_MARK_2
        );
        this.symbolMark3 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_MARK_3
        );
        this.symbolMark4 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_MARK_4
        );
        this.symbolMark5 = this.symbolMark4 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_MARK_5
        );

        this.symbolPoint1 = Number(item.SYMBOL_POINT_1);
        this.symbolPoint2 = Number(item.SYMBOL_POINT_2);
        this.symbolPoint3 = Number(item.SYMBOL_POINT_3);
        this.symbolPoint4 = Number(item.SYMBOL_POINT_4);
        this.symbolPoint5 = Number(item.SYMBOL_POINT_5);

        this.symbolExample1 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_EXAMPLE_1
        );
        this.symbolExample2 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_EXAMPLE_2
        );
        this.symbolExample3 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_EXAMPLE_3
        );
        this.symbolExample4 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_EXAMPLE_4
        );
        this.symbolExample5 = convertStr(
          config.EMPTY_STRING,
          '',
          item.SYMBOL_EXAMPLE_5
        );

        this.symbolExpiration1 = item.SYMBOL_EXPIRATION_1;
        this.symbolExpiration2 = item.SYMBOL_EXPIRATION_2;
        this.symbolExpiration3 = item.SYMBOL_EXPIRATION_3;
        this.symbolExpiration4 = item.SYMBOL_EXPIRATION_4;
        this.symbolExpiration5 = item.SYMBOL_EXPIRATION_5;

        // 総合目標タイトル
        this.totalGoalTitle1 = item.TOTAL_GOAL_TITLE_1;
        this.totalGoalTitle2 = item.TOTAL_GOAL_TITLE_2;
        this.totalGoalTitle3 = item.TOTAL_GOAL_TITLE_3;
        // 各種タイトル
        this.humanPowerTitle = item.HUMAN_POWER_TITLE;
        this.challengeGoalTitle = item.CHALLENGE_GOAL_TITLE;
        this.totalTargetTitle = item.TOTAL_TARGET_TITLE;
        this.commentTitle = item.COMMENT_TITLE;
        this.lastConfirmTitle = item.LAST_CONFIRM_TITLE;
        // 課題自己タイトル
        this.taskSelfTitle1 = item.TASK_SELF_TITLE_1;
        this.taskSelfTitle2 = item.TASK_SELF_TITLE_2;
        this.taskSelfTitle3 = item.TASK_SELF_TITLE_3;
        // 課題管理タイトル
        this.taskManageTitle1 = item.TASK_MANAGE_TITLE_1;
        this.taskManageTitle2 = item.TASK_MANAGE_TITLE_2;
        this.taskManageTitle3 = item.TASK_MANAGE_TITLE_3;
        // 作成状態
        this.userMakeStaus = config.EXEC_STOP;
        this.goalMakeStaus = config.EXEC_STOP;

        // システムオペレーターログイン名の取得
        this.get_sysop();

        // 組織キー非活性
        this.organizationKeyShow = true;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    get_sysop() {
      // システムオペレーション情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      axios
        .get(
          config.CONNECT_OWNER_URL +
            '/Owner/sysop/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.organizationKey
        )
        .then((response) => {
          // システムオペレータユーザ情報取得
          vm.items = response.data;
          this.sysopUserId = vm.items[0].USER_ID;
          /*
          this.sysopLoginId = vm.items[0].LOGIN_ID.replace(
            vm.items[0].ORGANIZATION_KEY,
            ''
          );
          */
          this.sysopLoginId = makeLoginId(
            vm.items[0].LOGIN_ID,
            vm.items[0].ORGANIZATION_KEY
          );

          this.sysopPassword = vm.items[0].PASSWORD;
          this.entrySysopPassword = this.sysopPassword.substr(0, 10);
          this.entrySysopPasswordRetry = this.entrySysopPassword;
        })
        .catch((error) => {
          this.sysopUserId = null;
          this.sysopLoginId = null;
          let errStr = '';
          if (error.response.status == 404) {
            errStr = 'システムオペレーターのユーザ情報が存在しません。';
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.organization_form.validate()) {
        return;
      }
      // 組織キー半角英数字チェック
      if (!this.organizationKey.match(/^[A-Za-z0-9]*$/)) {
        this.$refs.dialog.open(
          'info',
          '組織キーに半角英数字以外の文字が入力されています。\n 組織キーは半角英数字でご入力下さい。'
        );
        return;
      }
      // 初期パスワードチェック
      if (this.entryInitialPassword != this.entryInitialPasswordRetry) {
        this.$refs.dialog.open(
          'info',
          '初期パスワードとパスワード(再)の入力値が違います。\n再度、パスワードをご入力下さい。'
        );
        return;
      }
      // Hitonobi機能選択チェック
      if (this.chkHitonobi1 == false && this.chkHitonobi2 == false) {
        this.$refs.dialog.open(
          'info',
          'Hitonobiの機能が選択されていません。\n 「プラスの氣」または「人事考課」を選択してください。'
        );
        return;
      }
      // 運用開始日チェック
      let localStartOperatingDate = this.startOperatingDate.replaceAll(
        '-',
        '/'
      );
      if (!chackDateFormatStr(localStartOperatingDate)) {
        this.$refs.dialog.open(
          'info',
          '運用開始日が正しい日付ではありません。\n 運用開始日は西暦で「YYYY-MM-DD」の形式で入力してください。'
        );
        return;
      } else {
        this.startOperatingDate = this.startOperatingDate.replaceAll('/', '-');
      }
      // 運用終了日チェック
      if (this.endOperatingDate != null && this.endOperatingDate.trim()) {
        let localEndOperatingDate = this.endOperatingDate.replaceAll('-', '/');
        if (!chackDateFormatStr(localEndOperatingDate)) {
          this.$refs.dialog.open(
            'info',
            '運用終了日が正しい日付ではありません。\n 運用終了日は西暦で「YYYY-MM-DD」の形式で入力してください。'
          );
          return;
        } else {
          this.endOperatingDate = this.endOperatingDate.replaceAll('/', '-');
        }
      }
      // システムオペレーターパスワードチェック
      if (this.entrySysopPassword != this.entrySysopPasswordRetry) {
        this.$refs.dialog.open(
          'info',
          'システムオペレーターパスワードとパスワード(再)の入力値が違います。\n再度、パスワードをご入力下さい。'
        );
        return;
      }
      // 記号1
      if (this.symbolExpiration1 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark1) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('1'));
          return;
        }
        if (!this.symbolPoint1) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('1'));
          return;
        }
        if (!this.symbolExample1) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('1'));
          return;
        }
      }
      // 記号2
      if (this.symbolExpiration2 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark2) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('2'));
          return;
        }
        if (!this.symbolPoint2) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('2'));
          return;
        }
        if (!this.symbolExample2) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('2'));
          return;
        }
      }
      // 記号3
      if (this.symbolExpiration3 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark3) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('3'));
          return;
        }
        if (!this.symbolPoint3) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('3'));
          return;
        }
        if (!this.symbolExample3) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('3'));
          return;
        }
      }
      // 記号4
      if (this.symbolExpiration4 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark4) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('4'));
          return;
        }
        if (!this.symbolPoint4) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('4'));
          return;
        }
        if (!this.symbolExample4) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('4'));
          return;
        }
      }
      // 記号5
      if (this.symbolExpiration5 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark5) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('5'));
          return;
        }
        if (!this.symbolPoint5) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('5'));
          return;
        }
        if (!this.symbolExample5) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('5'));
          return;
        }
      }
      // 確認ダイアログ表示
      this.deleteFlg = false;
      if (this.entryFlg == true) {
        this.confirmMessage =
          this.organizationName +
          '様の組織情報を登録しますか？\n ※一度登録すると、組織キーは変更できません。';
      } else {
        this.confirmMessage =
          this.organizationName + '様の組織情報を登録しますか？';
      }
      this.$refs.confirm.open();
    },
    makeSymbolMarkErrMsg(symbolNumber) {
      let errMsg = '評価記号aが未入力です。評価記号aを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    makeSymbolPointErrMsg(symbolNumber) {
      let errMsg = 'ポイントaが未入力です。ポイントaを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    makeSymbolExampleErrMsg(symbolNumber) {
      let errMsg = '凡例aが未入力です。凡例aを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    delete_confirm() {
      // 入力チェック
      if (!this.$refs.organization_form.validate()) {
        // チェックエラー
        return;
      }

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      // 確認ダイアログ表示
      this.deleteFlg = true;
      this.confirmMessage =
        this.organizationName +
        '様の組織情報を削除しますか？\n ※本処理では、' +
        this.organizationName +
        '様の組織及びユーザ情報を削除します。';
      this.$refs.confirm.open();
    },
    editOrganizationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteOrganizationInfoRequest();
      } else {
        // 登録処理
        this.editOrganizationInfoRequest();
      }
    },
    editOrganizationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 組織情報作成
      if (this.entryFlg) {
        //----- 新規登録
        this.createdAt = moment().format('YYYYMMDDHHmmss');
        this.initialPassword = encrypt256(this.entryInitialPassword);

        this.sysopUserId =
          this.organizationKey + moment().format('YYYYMMDDHHmmss');
        this.sysopPassword = encrypt256(this.entrySysopPassword);
      } else {
        //----- 更新
        // 初期パスワード設定
        if (this.initialPassword != null && this.initialPassword.trim()) {
          let originalInitialPassword = this.initialPassword.substr(0, 10);
          if (originalInitialPassword != this.entryInitialPassword) {
            this.initialPassword = encrypt256(this.entryInitialPassword);
          }
        } else {
          this.initialPassword = encrypt256(this.entryInitialPassword);
        }
        // システムオペレーターパスワード設定
        if (this.sysopPassword != null && this.sysopPassword.trim()) {
          let originalSysopPassword = this.sysopPassword.substr(0, 10);
          if (originalSysopPassword != this.entrySysopPassword) {
            this.sysopPassword = encrypt256(this.entrySysopPassword);
          }
        } else {
          this.sysopPassword = encrypt256(this.entrySysopPassword);
        }
      }
      // 共通
      this.sysopLoginId = this.organizationKey + this.sysopLoginId;

      this.startOperatingDate = this.startOperatingDate.replaceAll('-', '');
      if (this.endOperatingDate != null && this.endOperatingDate.trim()) {
        this.endOperatingDate = this.endOperatingDate.replaceAll('-', '');
      } else {
        this.endOperatingDate = config.END_OPERATING_DATE;
      }

      if (this.chkHitonobi1 == true && this.chkHitonobi2 == false) {
        // プラスの氣
        this.expiration = config.EXPIRATION_PURASUNOKI;
      } else if (this.chkHitonobi1 == false && this.chkHitonobi2 == true) {
        // 人事考課
        this.expiration = config.EXPIRATION_JINJI;
      } else {
        // 両方
        this.expiration = config.EXPIRATION_BOTH;
      }

      this.updateAt = moment().format('YYYYMMDDHHmmss');

      axios
        .post(config.CONNECT_OWNER_URL + '/Owner/organization', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,

          ENTRY_FLG: this.entryFlg,

          ORGANIZATION_KEY: this.organizationKey,
          ORGANIZATION_NAME: this.organizationName,
          INITIAL_PASSWORD: this.initialPassword,
          COMMENT_MIN_STRING: this.commentMinString,
          START_OPERATING_DATE: this.startOperatingDate,
          END_OPERATING_DATE: this.endOperatingDate,
          EXPIRATION: this.expiration,
          USER_RANK_NAME_1: this.userRankName1,
          USER_RANK_NAME_2: this.userRankName2,
          USER_RANK_NAME_3: this.userRankName3,
          USER_RANK_NAME_4: this.userRankName4,
          USER_RANK_NAME_5: this.userRankName5,
          SYMBOL_MARK_1: this.symbolMark1,
          SYMBOL_MARK_2: this.symbolMark2,
          SYMBOL_MARK_3: this.symbolMark3,
          SYMBOL_MARK_4: this.symbolMark4,
          SYMBOL_MARK_5: this.symbolMark5,
          SYMBOL_POINT_1: this.symbolPoint1,
          SYMBOL_POINT_2: this.symbolPoint2,
          SYMBOL_POINT_3: this.symbolPoint3,
          SYMBOL_POINT_4: this.symbolPoint4,
          SYMBOL_POINT_5: this.symbolPoint5,
          SYMBOL_EXAMPLE_1: this.symbolExample1,
          SYMBOL_EXAMPLE_2: this.symbolExample2,
          SYMBOL_EXAMPLE_3: this.symbolExample3,
          SYMBOL_EXAMPLE_4: this.symbolExample4,
          SYMBOL_EXAMPLE_5: this.symbolExample5,
          SYMBOL_EXPIRATION_1: this.symbolExpiration1,
          SYMBOL_EXPIRATION_2: this.symbolExpiration2,
          SYMBOL_EXPIRATION_3: this.symbolExpiration3,
          SYMBOL_EXPIRATION_4: this.symbolExpiration4,
          SYMBOL_EXPIRATION_5: this.symbolExpiration5,
          TOTAL_GOAL_TITLE_1: this.totalGoalTitle1,
          TOTAL_GOAL_TITLE_2: this.totalGoalTitle2,
          TOTAL_GOAL_TITLE_3: this.totalGoalTitle3,
          HUMAN_POWER_TITLE: this.humanPowerTitle,
          CHALLENGE_GOAL_TITLE: this.challengeGoalTitle,
          TOTAL_TARGET_TITLE: this.totalTargetTitle,
          COMMENT_TITLE: this.commentTitle,
          LAST_CONFIRM_TITLE: this.lastConfirmTitle,
          TASK_SELF_TITLE_1: this.taskSelfTitle1,
          TASK_SELF_TITLE_2: this.taskSelfTitle2,
          TASK_SELF_TITLE_3: this.taskSelfTitle3,
          TASK_MANAGE_TITLE_1: this.taskManageTitle1,
          TASK_MANAGE_TITLE_2: this.taskManageTitle2,
          TASK_MANAGE_TITLE_3: this.taskManageTitle3,
          USER_MAKE_STATUS: this.userMakeStaus,
          GOAL_MAKE_STATUS: this.goalMakeStaus,
          CREATED_AT: this.createdAt,
          UPDATED_AT: this.updateAt,

          USER_ID: this.sysopUserId,
          LOGIN_ID: this.sysopLoginId,
          PASSWORD: this.sysopPassword,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.organizationName +
              message.MSG_INFO_OWNER_ORGANIZE_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }

          this.resolve(true);
          this.dialog = false;
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;
          // 表示制御
          this.showContent();

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
            this.resolve(true);
            this.dialog = false;
          } else if (error.response.status == 409) {
            errStr = message.MSG_INFO_ORGANIZATION_KEY_ALREADY_EXISTS;
            // 組織キーが既に存在している
            this.$refs.dialog.open('info', errStr);
            this.$refs.organizationKey.focus();
            return;
          } else if (error.response.status == 422) {
            errStr = message.MSG_INFO_SYSOP_LOGINID_ALREADY_EXISTS;
            // システムオペレーターのログイン名が既に存在している
            this.$refs.dialog.open('info', errStr);
            this.$refs.sysopLoginId.focus();
            return;
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
            this.resolve(true);
            this.dialog = false;
          }
        });
    },
    deleteOrganizationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- ユーザ作成状態チェック
      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/Organization/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.organizationKey
        )
        .then((response) => {
          let userMakeStatus = response.data[0].USER_MAKE_STATUS;
          if (userMakeStatus == config.EXEC_RUN) {
            // ローディング画像終了
            this.loading = false;

            // 1:実行中の場合は処理終了
            this.$refs.dialog.open(
              'info',
              '組織情報一括設定処理が実行中です。\n' +
                ' しばらく時間が経過した後に実行をお願いします。'
            );
            return;
          } else {
            //----- 組織データ一括削除リクエストPOST
            this.loading = true;
            axios
              .post(
                config.CONNECT_OWNER_URL + '/Owner/BulkDelete/organizations',
                {
                  SESSION_ID: userInfo.SESSION_ID,
                  SESSION_USER_ID: userInfo.USER_ID,
                  ORGANIZATION_KEY: this.organizationKey,
                }
              )
              .then((response) => {
                // ローディング画像終了
                this.loading = false;

                let msgStr = '';
                if (response.status == 200) {
                  msgStr =
                    '組織情報の一括削除処理を開始しました。\n' +
                    ' 削除処理には最大15分程度かかります。';
                  this.$refs.dialog.open('info', msgStr);
                  this.$emit('delete');
                }
                this.resolve(true);
                this.dialog = false;
              })
              .catch((error) => {
                // ローディング画像終了
                this.loading = false;

                let errStr = '';
                if (error.status == 400) {
                  errStr = message.MSG_ERROR_SESSION_ERROR + error;
                  this.$refs.dialog.open('error', errStr);
                } else {
                  errStr = message.MSG_ERROR_SYTEM_ERROR + error;
                  this.$refs.dialog.open('error', errStr);
                }
              });
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    showContent() {
      if (this.startOperatingDate != null && this.startOperatingDate.trim()) {
        // 運用開始日
        this.startOperatingDate = makeDateFormatStr(
          this.startOperatingDate,
          '/',
          '/',
          ''
        );

        // 運用終了日
        if (this.endOperatingDate != config.END_OPERATING_DATE) {
          this.endOperatingDate = makeDateFormatStr(
            this.endOperatingDate,
            '/',
            '/',
            ''
          );
        } else {
          this.endOperatingDate = null;
        }
      } else {
        this.startOperatingDate = null;
        this.endOperatingDate = null;
      }
      // システムオペレーターログインID
      this.sysopLoginId = this.sysopLoginId.replaceAll(
        this.organizationKey,
        ''
      );
    },
    cancel() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0.5rem;
  border-top: 5px solid #e55513;
}
</style>
